export default __webpack_public_path__ + "static/media/28.58f3e8f4.png";